import { buildAbilityFor } from 'config/ability';

import { useUserStore } from 'store/user.store';

export type UseUserHookType = ReturnType<typeof useUserHook>;
/**
 * used for getting the user from the redux store
 * default loginUser value in reducer is from the localStorage
 * @return {*} user object
 */
function useUserHook() {
    const user = useUserStore((state) => state.user);
    const isSwitchUser = useUserStore((state) => state.isSwitchUser);
    const ability = buildAbilityFor(user?.privilegeMap);

    return { ...user, isSwitchUser, ability };
}

export default useUserHook;
